var lx = lx || {};
lx.cart = lx.cart || {};

/* ex lxCart function*/
lx.cart.show = function () {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=CPC_BUY_CART",
            x01: pId
        },
        success: function (d) {
            $("#lx-buy-cart").dialog("close").remove();
            $(d).filter("#lx-buy-cart").dialog({
                modal: true,
                width: 540
            });
        }
    });
};

/* ex lxBuyRemove function*/
lx.cart.remove = function (pCartId) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=CPC_BUY_REMOVE",
            x01: pCartId
        },
        success: function (d) {
			apex.region("Cart_IR").refresh();
			location.reload(true);
			showTotal(); 
        }
    });
};

/* ex lxBuyAdd function*/
lx.cart.add = function (pCpc, pQty, pPage, pOrderId) {
		$.ajax({
			url: "wwv_flow.show",
			dataType: "text",
			traditional: true,
			cache: false,
			type: "POST",
			data: {
				p_flow_id: $v("pFlowId"),
				p_flow_step_id: $v("pFlowStepId"),
				p_instance: $v("pInstance"),
				p_request: "APPLICATION_PROCESS=CPC_BUY_ADD",
				x01: pCpc,
				x02: pQty,
				x03: pOrderId
			},
			success: function (d) {
				if (pPage == 51) {
				  apex.region("IR-CATALOG").refresh();
				} else {
					lx.cart.changeBtn('Btn-'+ pCpc + '', pQty, 'N');
					document.getElementById('Btn-'+ pCpc).setAttribute('onclick', 'lx.cart.update('+ pCpc +', $v("lx-buy-qty-'+pCpc+'"), '+ pOrderId +',204);');
					var lqty = $v('lx-buy-qty-'+pCpc);
					document.getElementById('lx-buy-qty-'+ pCpc).setAttribute('onchange', 'lx.cart.changeBtn("Btn-'+ pCpc +'", '+ lqty +',"Y");');
					location.reload(true);
				}
			}
		});
	
};

/* added on 12.03.2025 by Davor: works only on pg 51 */
lx.cart.checkQty = function (pCpcId, pQty, pPage, pProfileId, pOrderID, pAloType, pAddAction){
    apex.server.process("checkQty", {
        x01: pCpcId,
        x02: pQty
    }, {
            dataType: "json",
            success: function (d) {
                if (d.msg)
                    lx.info.actionConfirm({type:"danger",msg:d.msg, btn:"ok"});
                else if (pAddAction)
                    lx.cart.compare(pCpcId, pQty, pPage, pProfileId, pOrderID, pAloType, true);
            }
        });
}

lx.cart.compare = function (pCpc, pQty, pPage, pProfileId, pOrderID, pAloType, pQtyChecked) {
    if (isNaN(pQty)) apex.message.showErrors([{ type: "error", location: ["page"], message: 'Please enter valid number!', unsafe: false }])
    else if (pPage == 51 && !pQtyChecked)
        lx.cart.checkQty(pCpc, pQty, pPage, pProfileId, pOrderID, pAloType, true);
    else
		$.ajax({
			url: "wwv_flow.show",
			dataType: "text",
			traditional: true,
			cache: false,
			type: "POST",
			data: {
				p_flow_id: $v("pFlowId"),
				p_flow_step_id: $v("pFlowStepId"),
				p_instance: $v("pInstance"),
				p_request: "APPLICATION_PROCESS=COMPARE_CARTS",
				x01: pProfileId,
				x02: pAloType,
                x03: pCpc,
                x04: pQty
			},
			success: function (d) {
                apex.message.clearErrors();
				var BtnColor = $v('P'+ pPage +'_BTN_COLOR');
				if (pPage == 51) {
                  if (pOrderID == 0) { location.reload(true);} 
                  else { apex.region("IR-CATALOG").refresh();}  
				} else {
					lx.cart.changeBtn('Btn-'+ pCpc + '', pQty, 'N');
					document.getElementById('Btn-'+ pCpc).setAttribute('onclick', 'lx.cart.update('+ pCpc +', $v("lx-buy-qty-'+pCpc+'"), '+ pProfileId +',204);');
					var lqty = $v('lx-buy-qty-'+pCpc);
					document.getElementById('lx-buy-qty-'+ pCpc).setAttribute('onchange', 'lx.cart.changeBtn("Btn-'+ pCpc +'", '+ lqty +',"Y");');
				}
				$("#lxCart").addClass("t-Button--selected");
				$("#lxCart").css("background-color", BtnColor);
				$('#lxCart > .t-Button-label').text(lx.tran.get('SHOPPING_CART')+ ' '+ d);
			}
		});
	
};

lx.cart.changeBtn = function (pBtn,pQty,pUpdate,pCpc) {
    if (isNaN(pQty)) apex.message.showErrors([{ type: "error", location: ["page"], message: 'Please enter valid number!', unsafe: false }])
    else
        $.ajax({
                url: "wwv_flow.show",
                dataType: "text",
                traditional: true,
                cache: false,
                type: "POST",
                data: {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: "APPLICATION_PROCESS=UPDATAE_BULK_CART",
                    x01: pCpc,
                    x02: $v('lx-buy-qty-'+pCpc) //pQty
                },
                success: function (d) {
                    if (pUpdate == 'Y') {
                        if (pQty != 0) {
                        $('#'+ pBtn +' .t-Button-label').text(lx.tran.get('UPDATE_CART'));
                        $("#" + pBtn).removeClass("t-Button--hot");
                        }  
                        $("#" + pBtn).addClass("t-Button--hot");
                        $("#" + pBtn).removeAttr("disabled");
                    }else{
                        if (pQty != 0) {
                        $('#'+ pBtn +' .t-Button-label').text(lx.tran.get('ADDED_TO_CART'));
                        $("#" + pBtn).removeClass("t-Button--hot");
                        }  
                        $("#" + pBtn).addClass("t-Button--hot");
                        //$("#" + pBtn).removeAttr("disabled");
                        document.getElementById(pBtn).setAttribute('disabled','disabled');
                    }
                }
            });
	
}

lx.cart.update = function (pId, pQty, pOrderId, pPage) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=CPC_BUY_UPDATE",
            x01: pId,
            x02: pQty,
			x03: pOrderId			
        },
		success: function (d) {
			if (pPage == 51) {
			  apex.region("IR-CATALOG").refresh();
			} else if (pPage == 120) {
				apex.region("uiSummary").refresh();
				apex.region("Cart_IR").refresh();
			} else {
				lx.cart.changeBtn('Btn-'+ pId + '', pQty, 'N');
				document.getElementById('Btn-'+ pId).setAttribute('onclick', 'lx.cart.update('+ pId +', $v("lx-buy-qty-'+pId+'"), '+ pOrderId +',204);');
				var lqty = $v('lx-buy-qty-'+pId);
				document.getElementById('Qty-'+ pId).setAttribute('onchange', 'lx.cart.changeBtn("Btn-'+ pId +'", '+ lqty +',"Y");');
				/*$("#lxCart").addClass("t-Button--selected");
			    $('#lxCart > .t-Button-label').text(lx.tran.get('SHOPPING_CART')+ ' '+ d);*/
			}  			
			
        }
    });
};

/* ex lxBuyPO function*/
lx.cart.createPO = function (pProfile, pOpen, pText) {
    if (!pOpen) {
        var dialogId = 'LxPoDialog';
        var dialogDiv = '<div id="' + dialogId + '"><textarea id="PO_TEXT" rows="5" cols="34"></textarea></div>';
        var titlePO = apex.lang.getMessage("JS11");
        $(dialogDiv).dialog({
            modal: true,
            resizable: false,
            title: apex.lang.getMessage("JS10"),
            buttons: {
                titlePO: function () {
                    lxBuyPO(pProfile, 'Y', $v('PO_TEXT'));
                    $(this).closest('.ui-dialog-content').dialog('close');
                }
            },
            close: function (event, ui) {
                $(dialogDiv).dialog("destroy");
                $(dialogDiv).remove();
            }
        });
    } else {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=CPC_BUY_PO",
                x01: pProfile,
                x02: pText
            },
            success: function (d) {
                if (d == 0) {
                    alert(apex.lang.getMessage("JS12"));
                } else {
                    redirect(d);
                }
            }
        });
    }
};

lx.cart.updateField = {
    field: null,
    recId: null,
    $element: null,
    value: null,
    label: null,
    item: {label: null, type: "T", classResp: "col-12"},
    itemId: "lxUpdateField",
    dialog: {id: "cartUpdateField", maxWidth: "400px"}, 
    open: function (pField, pRecId, pThis, pValue) {
        this.field = pField;
        this.recId = pRecId;
        this.$element = $(pThis);
        if (pValue) this.value = pValue;
        else this.value = $(pThis).text();

        switch (this.field){
            case "CART_QTY": this.item.label = lx.tran.get('QUANTITY');
                            this.item.type = 'N';
                            break;
            default: null;
        }
        this.dialog.html = lx.item.gen({id: this.itemId, item: this.item, data: {r:this.value}});// '<div><input id="lxUpdateField" value="'+ this.value +'" /><div>';
        this.dialog.html = '<div class="row">'+ this.dialog.html +'</div>';
        this.dialog.buttons = [ {label: lx.tran.get('APPLY_CHANGES'), js: "lx.cart.updateField.submit()", class: "t-Button--primary"},
                                {label: lx.tran.get('CANCEL'), js: "lx.dialog.close(this)"}];
        if (!this.dialog.title) this.dialog.title = lx.tran.get('UPDATE_FIELD');
        lx.dialog.open(this.dialog);
    },
    submit: function (){
        this.value = lx.item.val({type: this.item.type, id: this.itemId});
        apex.server.process("fieldUpdate", {
            x01: this.field,
            x02: this.recId,
            x03: this.value
        }, {
			dataType: "json",
			success: function (d) {
                lx.cart.updateField.submitCallback(d);
            }
        });
    },
    submitCallback: function (d){
        var self = lx.cart.updateField;

        apex.message.clearErrors();
        if (d.success){
            self.$element.text(d.value);
            lx.dialog.close(null, self.dialog.id);
        } else if (d.err) apex.message.showErrors([{ type: "error", location: ["page"], message: d.err, unsafe: false }]);
        else apex.message.showErrors([{ type: "error", location: ["page"], message: "Something went wrong!", unsafe: false }]);
		apex.region("Cart_IR").refresh();
		showTotal(); 
    }
}

lx.cart.feedPurchase = function (pProfile, pAloId, pCpid, pCpidFol, pCpcId, pQty, pEventId) {
    $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=FEED_PURCHASE",
                x01: pProfile,
                x02: pAloId,
				x03: pCpid,
                x04: pCpidFol,
				x05: pCpcId,
                x06: pQty,
				x07: pEventId
            },
			success: function (d) {
				console.log("Raw response:", d);
				let cleanUrl = d.replace(/\(\d+\)/, "").trim();  

				console.log("Clean URL:", cleanUrl);

				if (cleanUrl.startsWith("http") || cleanUrl.startsWith("/")) {
					window.location.href = cleanUrl;
				} else {
					console.error("Invalid URL:", cleanUrl);
				}
			}

        });
};


lx.cart.renew = function (p_cpc_id, p_profile_id) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=RENEW_MEMBERSHIP",
            x01: p_cpc_id,
			x02: p_profile_id
        },
        success: function (d) {
			location.reload(true);
        }
    });
};
